import { render, staticRenderFns } from "./SBSignUpForm.html?vue&type=template&id=0598a122&scoped=true&"
import script from "./SBSignUpForm.ts?vue&type=script&lang=ts&"
export * from "./SBSignUpForm.ts?vue&type=script&lang=ts&"
import style0 from "./SBSignUpForm.css?vue&type=style&index=0&id=0598a122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598a122",
  null
  
)

export default component.exports